var React = require('react');

function LinkedinInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"id":"linkedin","key":0},"linkedin"),React.createElement("path",{"d":"M27.26 27.271h-4.733v-7.427c0-1.771-0.037-4.047-2.475-4.047-2.468 0-2.844 1.921-2.844 3.916v7.557h-4.739v-15.271h4.552v2.083h0.061c0.636-1.203 2.183-2.468 4.491-2.468 4.801 0 5.692 3.161 5.692 7.271v8.385zM7.115 9.912c-1.527 0-2.751-1.235-2.751-2.756 0-1.516 1.229-2.749 2.751-2.749s2.755 1.233 2.755 2.749c0 1.521-1.233 2.756-2.755 2.756zM9.489 27.271h-4.749v-15.271h4.749zM29.636 0h-27.276c-1.303 0-2.36 1.031-2.36 2.307v27.387c0 1.276 1.057 2.307 2.36 2.307h27.271c1.301 0 2.369-1.031 2.369-2.307v-27.387c0-1.276-1.068-2.307-2.369-2.307z","key":1})]);
}

LinkedinInline.defaultProps = {"version":"1.1","width":"20","height":"20","viewBox":"0 0 32 32"};

module.exports = LinkedinInline;

LinkedinInline.default = LinkedinInline;
